import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';
import { CustomerService } from '../../features/customers/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { UploadClientDetailsDialog } from '../client-details/client-details.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
// import * as selectPermissions from '../../core/permissions/permission.selector';
// import { Store } from '@ngrx/store';

@Component({
  selector: 'app-clients',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    AgGridAngular,
    ReactiveFormsModule,
    FormsModule,
    // PermissionDirective
  ],
  templateUrl: './clients.component.html',
  styleUrl: './clients.component.scss',
})
export class ClientsComponent {
  public viewPortSize: boolean = false;
  search: any;
  public rowData: any[] | null = null;
  readonly dialog = inject(MatDialog);
  searchInputControl: FormControl = new FormControl();
  columnDefs: (
    | {
        headerName: string;
        field: string;
        flex: number;
        cellRenderer: (params: any) => string;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        headerName: string;
        field: string;
        flex: number;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        field: string;
        headerName: string;
        flex: number;
        cellRenderer: (params: any) => HTMLDivElement;
        floatingFilter: boolean;
        filter: boolean;
      }
  )[];
  // profileName: any;
  // Permission = Permission;
  canListCustomers$ = this.permissionService.hasPermission(
    ModuleIds.Customers,
    'List'
  );
  canCreateCustomers$ = this.permissionService.hasPermission(
    ModuleIds.ChartAccount,
    'Create'
  );
  canEditCustomers$ = this.permissionService.hasPermission(
    ModuleIds.ChartAccount,
    'Edit'
  );
  canDeleteCustomers$ = this.permissionService.hasPermission(
    ModuleIds.ChartAccount,
    'Delete'
  );
  canDetailsCustomers$ = this.permissionService.hasPermission(
    ModuleIds.ChartAccount,
    'Details'
  );
  canDeleteCustomers: boolean = false;
  canEditCustomers: boolean = false;
  canDetailsCustomers: boolean = false;

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private toastr: ToastrService,
    // private store: Store
    private permissionService: PermissionService
  ) {
    // const loggedInUser: any = localStorage.getItem('loggedInUser');
    // const userData = JSON.parse(loggedInUser);
    // this.profileName = userData?.profileData?.profileName;
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  openDialog() {
    const dialogRef = this.dialog.open(UploadClientDetailsDialog, {
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.fetchCustomers();
    });
  }

  ngOnInit() {
    this.fetchCustomers();
    this.searchInputControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value) => {
        this.search = value;
        this.fetchCustomers();
      });

    this.checkViewportSize();
    this.canDeleteCustomers$.subscribe((val) => {
      this.canDeleteCustomers = val;
    });
    this.canEditCustomers$.subscribe((val) => {
      this.canEditCustomers = val;
    });
    this.canDetailsCustomers$.subscribe((val) => {
      this.canDetailsCustomers = val;
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        headerName: 'Customer Name',
        field: 'name',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          return `
          <div style="display: flex; align-items: center;">
            <span>${params.data.name}</span>
          </div>
        `;
        },
      },
      {
        headerName: 'Email',
        field: 'email',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Phone No',
        field: 'phone',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Address',
        field: 'address',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Country',
        field: 'country',
        flex: this.viewPortSize ? 1 : 0,
      },
      // {
      //   headerName: 'Unused Credits',
      //   field: 'credits',
      //   flex: this.viewPortSize ? 1 : 0,
      //   cellRenderer: (params: any) => {
      //     return `
      //   <div style="display: flex; align-items: center;">
      //     <span>AED ${parseFloat(params.data.credits).toFixed(2)}</span>
      //   </div>
      // `;
      //   },
      // },
      {
        field: 'action',
        headerName: 'Actions',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.gap = '20px';

          const editIcon = document.createElement('img');
          editIcon.src = 'assets/images/icons/icon-edit.svg';
          editIcon.style.cursor = 'pointer';
          editIcon.setAttribute('data-action', 'edit');

          // this.store.select(selectPermissions.hasPermission('4', Permission.Edit)).subscribe((canEdit) => {
          //     container.appendChild(editIcon);
          //   }
          // });
          if (this.canEditCustomers) {
            container.appendChild(editIcon);
          }
          const deleteIcon = document.createElement('img');
          deleteIcon.src = 'assets/images/icons/icon-delete.svg';
          deleteIcon.style.cursor = 'pointer';
          deleteIcon.setAttribute('data-action', 'delete');

          // if (this.profileName === 'admin') {
          //   container.appendChild(deleteIcon);
          // }

          // this.store.select(selectPermissions.hasPermission('4', Permission.Delete)).subscribe((canDelete) => {
          //     container.appendChild(deleteIcon);
          // });
          if (this.canDeleteCustomers) {
            container.appendChild(deleteIcon);
          }

          return container;
        },
        floatingFilter: false,
        filter: false,
      },
    ];
  }
  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';

  onCellClicked(params: any) {
    const customerId = params.data?.id;
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        this.onEdit(customerId);
      } else if (action === 'delete') {
        this.onConfirmDelete(customerId);
      }
    } else {
      // this.router.navigate([`/customers/customer-details/${customerId}`]);
      if(this.canDetailsCustomers){
      this.router.navigate(['/customers/customer-details'], {
        // queryParams: { id: customerId, partners: this.rowData},
        queryParams: { id: customerId },
      });
    }
    }
  }

  fetchCustomers() {
    this.customerService.fetchCustomers(this.search).subscribe({
      next: (data: any) => {
        this.rowData = data.map((customer: any) => {
          return {
            id: customer?.id ?? '--',
            name:
              `${customer?.firstName ?? ''} ${
                customer?.lastName ?? ''
              }`.trim() || '--',
            email: customer?.email ?? '--',
            phone: customer?.phoneNumber ?? '--',
            address: customer?.address ?? '--',
            country: customer?.country ?? '--',
          };
        });
      },
      error: (error) => {
        this.toastr.error(error?.message || 'Failed to fetch customers');
      },
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    this.search = input.value;
    this.fetchCustomers();
  }

  onConfirmDelete(id: number): void {
    console.log(id);

    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.onDelete(id);
      }
    });
  }

  onDelete(id: any) {
    this.customerService.removeCustomer(id).subscribe({
      next: (result) => {
        if (result) {
          this.toastr.success('Customer deleted successfully', 'Success');
          this.fetchCustomers();
        }
      },
      error: (error) => {
        this.toastr.error(error, 'Error');
      },
    });
  }

  onEdit(id: any) {
    this.router.navigate([`/customers/customer-edit/${id}`]);
  }
}

@Component({
  selector: 'upload-clients-dialog',
  templateUrl: 'upload-clients-dialog.html',
  styleUrls: ['./clients.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class UploadClientsDialog {
  file: any = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Selected file:', file);
      this.file = file;
    }
  }
}
